import { HttpService } from "./http";
import { API_BASE_URL } from "../constants/API";

const Endpoint = {
  fetchPromotionalCicleList: `${API_BASE_URL}/promotionalCicles`,
};

export class PromotionalCicleService {
  /**
   * @param {{ term: string }} data
   */
  static async fetchPromotionalCicleList(data) {
    const params =
      data.term.length >= 1
        ? {
            promotionalCicleName: data.term,
          }
        : {};

    const response = await HttpService.get(
      Endpoint.fetchPromotionalCicleList,
      params
    );

    return response;
  }
}

export default PromotionalCicleService;
